import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  top: 1.7rem;
  right: 10px;
  cursor: pointer;
`;
